import { FC, useEffect } from "react"
import * as api from "../../app/data/tribeSwaggerApi"

import { FavoriteEventList } from "./list/FavoriteEventList"
import { favoriteDtoToModel } from "./mapper"

export type FavoritePageProps = {
  userId: string
}
const FavoritePage: FC<FavoritePageProps> = ({ userId }) => {
  const { isLoading, data, isSuccess, refetch, error } =
    api.useGetAllFavoritesByUserIdQuery({
      userId: userId,
    })

  useEffect(() => {
    if (data) {
      refetch()
    }
  }, [])

  if (isSuccess && data) {
    const favoriteEvents = data.map(favoriteDtoToModel);

    return (
      <FavoriteEventList
        onChange={refetch}
        list={favoriteEvents}
      />
    )
  }
  return null;
}

export default FavoritePage

